/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React, { useState } from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { filterCollectionStories, getCollectionStories, getAuthorStories } from "../../utils";
import { useSelector } from "react-redux";

const WithSubsequentLoad = Component => {
  const WrappedComponent = ({ collection, config = {} }) => {
    const mountAtPrefix = useSelector(state => get(state, ["qt", "config", "mountAt"], ""));
    const pageType = useSelector(state => get(state, ["qt", "pageType"], ""));
    const initialLoadCount = parseInt(get(config, ["initialLoadCount"], 4));
    const collectionStories = filterCollectionStories(collection.items);
    const initialCollectionItems = collectionStories.slice(0, initialLoadCount);
    const [collectionItems, setCollectionItems] = useState(initialCollectionItems);
    const [isLoading, setIsLoading] = useState(false);
    const intialLoadMoreButtonState = initialCollectionItems.length >= initialLoadCount;
    const [isLoadMoreVisible, setIsLoadMoreVisible] = useState(intialLoadMoreButtonState);
    const updatedCollection = { ...collection, items: collectionItems };

    const getMoreStories = async (offset, limit) => {
      setIsLoading(true);
      let response;
      if (pageType === "author-page") {
        const authorId = get(collectionItems, ["0", "story", "author-id"], "");
        response = await getAuthorStories(authorId, offset, limit, mountAtPrefix);
      } else {
        response = await getCollectionStories(collection.slug, offset, limit, mountAtPrefix);
      }
      if (response.items.length) {
        setCollectionItems([...collectionItems, ...response.items]);
      } else {
        setIsLoadMoreVisible(false);
      }
      setIsLoading(false);
    };

    return (
      <Component
        collection={updatedCollection}
        config={config}
        getMoreStories={getMoreStories}
        isLoadMoreVisible={isLoadMoreVisible}
        isLoading={isLoading}
      />
    );
  };

  WrappedComponent.propTypes = {
    collection: PropTypes.object.isRequired,
    config: PropTypes.object.isRequired
  };

  return WrappedComponent;
};

export default WithSubsequentLoad;
